import store from '../../store/index';
import captureRenderBlockingException from '../../tracking/helpers/captureRenderBlockingException';
import updateDataAnalyticsLayer from '../../tracking/adobe/updateDataAnalyticsLayer';

export default async function beforeEnterReg1(to, from, next) {
  try {
    if (store.state.isLoggedIn) {
      const result = await store.dispatch('fetchAndUpdateState', undefined, { root: true });
      if (result === false) {
        return;
      }

      window.history.pushState({}, null, from);
      store.dispatch('setAwaitingNavigation', false);
      next('/v/pessoal');
    } else {
      updateDataAnalyticsLayer();
      next();
    }
  } catch (e) {
    store.dispatch('setBackendErrorMessage');
    captureRenderBlockingException(e);
    next();
  }
}
